import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { type ReactNode } from 'react';

interface Props {
  icon: ReactNode;
  title: string;
  description: string;
  /** The last decision note from the Bodyprint team, shown as a quote. */
  note?: { label: string; text: string } | null;
  actions: ReactNode;
}

/** Full-page account state (designs P06 and P07): icon, message, the team's note and the next step. */
const StatusGate = ({ icon, title, description, note, actions }: Props) => (
  <Stack alignItems="center" textAlign="center" gap={2} sx={sx.root}>
    {icon}
    <Typography component="h1" variant="h2">
      {title}
    </Typography>
    <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 540 }}>
      {description}
    </Typography>
    {note ? (
      <Alert severity="error" sx={sx.note}>
        <AlertTitle>{note.label}</AlertTitle>
        {note.text}
      </Alert>
    ) : null}
    <Stack direction={{ xs: 'column', sm: 'row' }} gap={1.5} sx={{ mt: 1 }}>
      {actions}
    </Stack>
  </Stack>
);

export default StatusGate;

const sx = {
  root: { py: { xs: 6, md: 10 }, px: 2 },
  note: { width: '100%', maxWidth: 560, textAlign: 'left' },
};
